/** @format */

export const XMedium = ({color}) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.6663 8.27334L15.7263 7.33334L11.9997 11.06L8.27301 7.33334L7.33301 8.27334L11.0597 12L7.33301 15.7267L8.27301 16.6667L11.9997 12.94L15.7263 16.6667L16.6663 15.7267L12.9397 12L16.6663 8.27334Z"
                fill={color}
            />
            <rect x="1" y="1" width="22" height="22" rx="11" stroke="#323232" stroke-width="2" />
        </svg>
    );
};
